import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useMemo } from "react";
import { PsychologistAction } from "src/apis/action";
import NoDataAlert from "src/pages/components/NoDataAlert";
import { formatDateToBR } from "src/utils/date";

type MyActionsTableProps = {
  actions: PsychologistAction[],
}

const MyActionsTable: React.FC<MyActionsTableProps> = ({ actions }): JSX.Element => {
  const hasActions = useMemo(() => Boolean(actions) && actions.length > 0, [actions]);

  return hasActions ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Título</strong></TableCell>
            <TableCell><strong>Ação</strong></TableCell>
            <TableCell><strong>Atendimento</strong></TableCell>
            <TableCell><strong>Participantes</strong></TableCell>
            <TableCell><strong>Empresa</strong></TableCell>
            <TableCell><strong>Remuneração</strong></TableCell>
            <TableCell><strong>Situação</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {actions?.map((action) => (
            <TableRow key={action.id}>
              <TableCell>{action.id}</TableCell>
              <TableCell>{action.titulo ?? "-"}</TableCell>
              <TableCell>{action.acao}</TableCell>
              <TableCell>{formatDateToBR(action.data)}</TableCell>
              <TableCell>{action.numero_participantes ?? "-"}</TableCell>
              <TableCell>{action.empresa}</TableCell>
              <TableCell>R$ {action.remuneracao}</TableCell>
              <TableCell>
                {action.rejeitada ? (
                  <Chip size="small" label="Rejeitada" color="error" />
                ) : (
                  "-"
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  );
}

export default MyActionsTable;
